import { useEffect, useState } from 'react';
import { useWindowDimensions } from "react-native";

export function useWindowSize() {
  const window = useWindowDimensions();
  const [isMobile, setIsMobile] = useState<boolean>(window.width < 620);
  const [isTablet, setIsTablet] = useState<boolean>(window.width < 720);

  useEffect(() => {
    setIsMobile(window.width < 620);
    setIsTablet(window.width < 720);
  }, [window]);

  return { height: window.height, width: window.width, isMobile, isTablet };
}
